var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damageMobilier-category1" },
    [
      _c("maNotificationsTop", {
        attrs: { errorMsgGeneral: _vm.errorMsg, errorIsVisible: _vm.error },
      }),
      !_vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-category", {
                attrs: {
                  titleNavbar: _vm.titleCategory,
                  handleClickBack: _vm.handleBackButtonClick,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-stepper", {
                attrs: {
                  numberOfStep: 2,
                  textOfStep: _vm.$t("Déclaration des dommages"),
                  handleClickBack: _vm.handleBackButtonClick,
                  arrowIsAllow: true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "container" }, [
        _vm.formData.options
          ? _c(
              "ul",
              { staticClass: "listCategories" },
              _vm._l(_vm.formData.options, function (category) {
                return _c("li", [
                  _c(
                    "div",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleClickCategory(
                            _vm.formData.name,
                            category.key,
                            _vm.formData.id,
                            category.literal
                          )
                        },
                      },
                    },
                    [
                      _c("p", { staticClass: "text-medium grayLightMouse" }, [
                        _vm._v(_vm._s(category.literal)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "arrowSvg" },
                        [
                          _c("svgicon", {
                            attrs: {
                              icon: "arrow_right",
                              height: "17",
                              width: "10",
                              color: "#C5CACF",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              }),
              0
            )
          : _vm.formType === "uptecCpi"
          ? _c(
              "div",
              { staticClass: "container-form_cpi" },
              [
                _c(
                  "p",
                  { staticClass: "gray headline-large mg mg--t-4 mg--b-1" },
                  [_vm._v(_vm._s(_vm.titleCategory))]
                ),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-5" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
                _c("ma-date-picker", {
                  attrs: {
                    errorInput: _vm.errorDate,
                    handleChangeInput: _vm.handleChangeInputDate,
                    literal: _vm.$t("datePicker.literal"),
                  },
                }),
                _c("ma-input-txt", {
                  staticClass: "price-input mg mg--b-5",
                  attrs: {
                    type: "text",
                    required: "",
                    name: "inputPrice",
                    col: "4",
                    icon: "",
                    literal: _vm.$t("damageMobilier.category.price"),
                    inputError: _vm.errorPrice,
                    inputTextError: _vm.$t(
                      "damageMobilier.category.inputTextError"
                    ),
                  },
                  model: {
                    value: _vm.inputValPrice,
                    callback: function ($$v) {
                      _vm.inputValPrice = $$v
                    },
                    expression: "inputValPrice",
                  },
                }),
                _c("ma-input-file", {
                  attrs: {
                    titleInput: _vm.$t("damageDetails.titleFileInputPres"),
                    name: "inputImgPres",
                    imageList: _vm.imgListPres,
                  },
                  on: { "file:src": _vm.handleImgChangePres },
                }),
                _c(
                  "div",
                  { staticClass: "container-buttons" },
                  [
                    _c(
                      "ma-add-damages",
                      {
                        staticClass: "buttonAddDamages",
                        attrs: {
                          handleButtonClick: _vm.handleOpenModal,
                          title: _vm.$t("addDamages.buttonTitle"),
                          shouldBeDisabled:
                            !_vm.inputValPrice || !_vm.inputValDate,
                          btnType: _vm.getBtnType,
                        },
                      },
                      [
                        _c("p", { staticClass: "text-medium" }, [
                          _vm._v(_vm._s(_vm.$t("home.buttonTxt")) + " "),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "ma-modal",
                  {
                    ref: "modalConfirmation",
                    staticClass: "modal-confirmation",
                    attrs: { type: "small" },
                    on: { "modal:close": _vm.closeModaConfirmation },
                  },
                  [
                    _c("template", { slot: "modalContent" }, [
                      _c(
                        "div",
                        { staticClass: "modal__main" },
                        [
                          _c(
                            "p",
                            { staticClass: "gray headline-large mg mg--b-3" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("damageMobilier.category.modal1")
                                ) + " "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "gray text-medium-large mg mg--b-5",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("damageMobilier.category.modal2")
                                ) + " "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.date")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-medium grayLightMouse mg mg--b-5",
                            },
                            [_vm._v(_vm._s(_vm.showDateWithCorrectForm))]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-1" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("damageMobilier.category.price")
                                ) + " "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-medium grayLightMouse mg mg--b-5",
                            },
                            [_vm._v(_vm._s(_vm.inputValPrice))]
                          ),
                          _c("ma-add-damages", {
                            staticClass: "buttonsNextActions",
                            attrs: {
                              handleButtonClick: _vm.handleAddDamagesCpi,
                              handleButtonClickWhiteBtn:
                                _vm.closeModaConfirmation,
                              title: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitle"
                              ),
                              titleWhiteBtn: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitleWhiteBtn"
                              ),
                              btnType: "functionalBtnWhite",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm.formType === "formInputsMobilier"
          ? _c(
              "div",
              { staticClass: "container-form" },
              [
                _c(
                  "p",
                  { staticClass: "gray headline-large mg mg--t-4 mg--b-1" },
                  [_vm._v(_vm._s(_vm.titleCategory))]
                ),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-5" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
                _c("ma-form", {
                  key: _vm.formKey,
                  attrs: {
                    type: "large",
                    formData: _vm.formData.form,
                    titleFileInputPres: _vm.$t(
                      "damageDetails.titleFileInputPres"
                    ),
                    nameFileInputPres: "inputImgPres",
                    inputImgListPres: _vm.imgListPres,
                  },
                  on: {
                    change: function ($event) {
                      _vm.handleFormChange($event)
                      _vm.handleNestedComponents($event)
                    },
                    "file:change-pres": _vm.handleImgChangePres,
                  },
                  nativeOn: {
                    focus: function ($event) {
                      return _vm.handleInputFocus()
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "container-buttons" },
                  [
                    _c(
                      "ma-add-damages",
                      {
                        staticClass: "buttonAddDamages",
                        attrs: {
                          handleButtonClick: _vm.handleAddDamages,
                          title: _vm.$t("addDamages.buttonTitle"),
                          shouldBeDisabled: _vm.isDisabledBtn,
                          btnType: _vm.getBtnType,
                        },
                      },
                      [
                        _c("p", { staticClass: "text-medium" }, [
                          _vm._v(_vm._s(_vm.$t("home.buttonTxt")) + "        "),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }